export function createSources(x1, x2) {
  return {
    src: x1,
    srcset: `${x1} 1x, ${x2} 2x`,
    imageset: `url(${x1}) 1x, url(${x2}) 2x`,
  };
}
export const createImagesModule = () => {
  return {
    state: {},
    getters: {
      img_introduction_cable: () => {
        return require("@/assets/images/Introduction_Cable.png");
      },
      img_arrow_right: () => {
        return createSources(
          require("@/assets/images/Icon-Arrow-Right.png"),
          require("@/assets/images/Icon-Arrow-Right@2x.png"),
        );
      },
      img_download: () => {
        return createSources(
          require("@/assets/images/Icon-Download-BlackCirc.png"),
          require("@/assets/images/Icon-Download-BlackCirc@2x.png"),
        );
      },
      img_download_white_squre: () => {
        return createSources(
          require("@/assets/images/Icon-Download-WhiteSquare.png"),
          require("@/assets/images/Icon-Download-WhiteSquare@2x.png"),
        );
      },
      img_surgeon: () => {
        return createSources(
          require("@/assets/images/Surgeon.png"),
          require("@/assets/images/Surgeon@2x.png"),
        );
      },
      img_surgeon_wide: () => {
        return require("@/assets/images/SurgeonWide.png");
      },
      img_beam_forms: () => {
        return createSources(
          require("@/assets/images/BeamForms.png"),
          require("@/assets/images/BeamForms@2x.png"),
        );
      },
      img_membrane_filter: () => {
        return createSources(
          require("@/assets/images/MembraneFilter.png"),
          require("@/assets/images/MembraneFilter@2x.png"),
        );
      },
      img_arrow_down: () => {
        return createSources(
          require("@/assets/images/Icon-Arrow-Down.png"),
          require("@/assets/images/Icon-Arrow-Down@2x.png"),
        );
      },
      img_slider_right: () => {
        return createSources(
          require("@/assets/images/Icon-Slider-Right.png"),
          require("@/assets/images/Icon-Slider-Right@2x.png"),
        );
      },
      img_close: () => {
        return createSources(
          require("@/assets/images/Icon-Close.png"),
          require("@/assets/images/Icon-Close@2x.png"),
        );
      },
      img_modes_header: () => {
        return createSources(
          require("@/assets/images/Icon-PreciseAPC.png"),
          require("@/assets/images/Icon-PreciseAPC@2x.png"),
        );
      },
      img_modes_pulsed: () => {
        return createSources(
          require("@/assets/images/Icon-PulsedAPC.png"),
          require("@/assets/images/Icon-PulsedAPC@2x.png"),
        );
      },
      img_modes_forced: () => {
        return createSources(
          require("@/assets/images/Icon-ForcedAPC.png"),
          require("@/assets/images/Icon-ForcedAPC@2x.png"),
        );
      },
      img_outro_background: () => {
        return createSources(
          require("@/assets/images/Outro_Background.jpg"),
          require("@/assets/images/Outro_Background@2x.jpg"),
        );
      },
      img_testimonial_face1: () => {
        return createSources(
          require("@/assets/images/Testimonial_1_face.jpg"),
          require("@/assets/images/Testimonial_1_face.jpg"),
        );
      },
      img_fiapc_probes: () => {
        return createSources(
          require("@/assets/images/FiAPC-probes.png"),
          require("@/assets/images/FiAPC-probes@2x.png"),
        );
      },
      img_pdf_preview_gastro_de: () => {
        return createSources(
          require("@/assets/images/pdf_preview_gastro_de.png"),
          require("@/assets/images/pdf_preview_gastro_de.png"),
        );
      },
      img_pdf_preview_gastro_en: () => {
        return createSources(
          require("@/assets/images/pdf_preview_gastro_en.png"),
          require("@/assets/images/pdf_preview_gastro_en.png"),
        );
      },
      img_pdf_preview_pocket_guide_de: () => {
        return createSources(
          require("@/assets/images/pdf_preview_pocket_guide_de.png"),
          require("@/assets/images/pdf_preview_pocket_guide_de.png"),
        );
      },
      img_pdf_preview_pocket_guide_en: () => {
        return createSources(
          require("@/assets/images/pdf_preview_pocket_guide_en.png"),
          require("@/assets/images/pdf_preview_pocket_guide_en.png"),
        );
      },
      img_pdf_preview_principles_apc_de: () => {
        return createSources(
          require("@/assets/images/pdf_preview_principles_apc_de.png"),
          require("@/assets/images/pdf_preview_principles_apc_de.png"),
        );
      },
      img_pdf_preview_principles_apc_en: () => {
        return createSources(
          require("@/assets/images/pdf_preview_principles_apc_en.png"),
          require("@/assets/images/pdf_preview_principles_apc_en.png"),
        );
      },
      img_pdf_preview_singleuse_de: () => {
        return createSources(
          require("@/assets/images/pdf_preview_singleuse_de.png"),
          require("@/assets/images/pdf_preview_singleuse_de.png"),
        );
      },
      img_pdf_preview_singleuse_en: () => {
        return createSources(
          require("@/assets/images/pdf_preview_singleuse_en.png"),
          require("@/assets/images/pdf_preview_singleuse_en.png"),
        );
      },
      img_pdf_preview_sterile_de: () => {
        return createSources(
          require("@/assets/images/pdf_preview_sterile_de.png"),
          require("@/assets/images/pdf_preview_sterile_de.png"),
        );
      },
      img_pdf_preview_sterile_en: () => {
        return createSources(
          require("@/assets/images/pdf_preview_sterile_en.png"),
          require("@/assets/images/pdf_preview_sterile_en.png"),
        );
      },
      img_download_preview2: () => {
        return createSources(
          require("@/assets/images/Download-Preview2.png"),
          require("@/assets/images/Download-Preview2.png"),
        );
      },
      img_thumbnail_212574130: () => {
        return createSources(
          require("@/assets/images/thumbnail-212574130.jpeg"),
          require("@/assets/images/thumbnail-212574130.jpeg"),
        );
      },
      img_thumbnail_230571947: () => {
        return createSources(
          require("@/assets/images/thumbnail-230571947.jpeg"),
          require("@/assets/images/thumbnail-230571947.jpeg"),
        );
      },
      img_thumbnail_230593602: () => {
        return createSources(
          require("@/assets/images/thumbnail-230593602.jpeg"),
          require("@/assets/images/thumbnail-230593602.jpeg"),
        );
      },
      img_thumbnail_395895502: () => {
        return createSources(
          require("@/assets/images/thumbnail-395895502.jpeg"),
          require("@/assets/images/thumbnail-395895502.jpeg"),
        );
      },
      img_thumbnail_435672509: () => {
        return createSources(
          require("@/assets/images/thumbnail-435672509.jpeg"),
          require("@/assets/images/thumbnail-435672509.jpeg"),
        );
      },
      img_thumbnail_chronic_bleeding: () => {
        return createSources(
          require("@/assets/images/ClinicalApplication/chronic-bleeding.jpg"),
          require("@/assets/images/ClinicalApplication/chronic-bleeding.jpg"),
        );
      },
      img_thumbnail_coag_residual_tissue: () => {
        return createSources(
          require("@/assets/images/ClinicalApplication/coag-residual-tissue.jpg"),
          require("@/assets/images/ClinicalApplication/coag-residual-tissue.jpg"),
        );
      },
      img_thumbnail_non_variceal_bleeding: () => {
        return createSources(
          require("@/assets/images/ClinicalApplication/non-variceal-bleeding.jpg"),
          require("@/assets/images/ClinicalApplication/non-variceal-bleeding.jpg"),
        );
      },
      img_thumbnail_stent_trimming: () => {
        return createSources(
          require("@/assets/images/ClinicalApplication/stent-trimming.jpg"),
          require("@/assets/images/ClinicalApplication/stent-trimming.jpg"),
        );
      },
      img_thumbnail_tumor_ablation: () => {
        return createSources(
          require("@/assets/images/ClinicalApplication/tumor-ablation.jpg"),
          require("@/assets/images/ClinicalApplication/tumor-ablation.jpg"),
        );
      },
    },
  };
};